import {DayOfWeekList} from '../../../graphql/generated/types';
import {DayOfWeekSection} from './DayOfWeekSection';

interface Props {
  columnData: DayOfWeekList;
}

export const DayOfWeekColumnTitle = ({columnData}: Props) => {
  return (
    <DayOfWeekSection.Column>
      <DayOfWeekSection.Column.Title>
        {columnData.title}
      </DayOfWeekSection.Column.Title>
    </DayOfWeekSection.Column>
  );
};
